import { Box, CircularProgress } from '@mui/material';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

interface GridContainerProps {
  children: ReactNode;
  emptyState: ReactNode;
  isEmpty: boolean;
  loading?: boolean;
}

export const GridContainer = ({ children, emptyState, isEmpty, loading }: GridContainerProps) => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
        <CircularProgress aria-label={t('common.status.loading')} />
      </Box>
    );
  }

  return <>{isEmpty ? emptyState : children}</>;
};
